<template>
  <memlist-card>
    <div class="d-flex justify-end">
      <memlist-icon-button
        class="mb-2"
        icon="menu-icon flaticon2-plus"
        :text="$t('PAGES.TERMS.NEW')"
        variant="primary"
        @click="createTermClicked"
      />
    </div>


    <div class="table-responsive">
      <table class="table table-head-custom table-vertical-center table-head-bg table-borderless table-striped w-100">
        <thead>
          <tr class="text-left w-100">
            <th>{{$t('COMMON.ACTIVE')}}</th>
            <th>{{$t('COMMON.NAME')}}</th>
            <th>{{$t('COMMON.TYPE')}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, i) in terms">
            <ConfirmTermsTableRow
              v-bind:key="i"
              :term="item"
              :currentCompanyId="currentCompanyId"
              @selectTermClicked="selectTermClicked"
              @deleteTermClicked="deleteTermClicked"
              @isActiveChanged="isActiveChanged"
              @toastr="toastr"
            />
          </template>
        </tbody>
      </table>
    </div>
    
    <div class="scroll-to-container"></div>

    <memlist-card v-if="creating || editing">
      <memlist-text-input
        id="input-id"
        v-model="form.id"
        :title="'ID'"
        layout="vertical"
        type="text"
        required
        disabled
      />
      <memlist-checkbox
        class="mt-4"
        v-model="form.is_mandatory"
        :text="$t('COMMON.MANDATORY')"
      />

      <memlist-checkbox
        class="mt-4"
        v-model="form.is_active"
        :text="$t('COMMON.ACTIVE')"
      />

      <memlist-text-input
        class="mt-4"
        id="input-name"
        v-model="form.name"
        :title="$t('COMMON.NAME')"
        layout="vertical"
        type="text"
      />

      
      <memlist-inline-alert variant="info">
        {{ $t('PAGES.TERMS.TERMS_TEXT_INFO') }}
      </memlist-inline-alert>

      <memlist-text-input
        class="mt-4"
        id="input-descr"
        v-model="form.descr"
        :title="$t('PAGES.TERMS.CHECKBOX_TEXT')"
        layout="vertical"
        type="text"
      />

      <memlist-tiptap
        class="mt-4"
        id="html"
        v-model="form.template"
        :title="$t('PAGES.TERMS.TEXT')"
        layout="vertical"
        type="text"
      />

      <div class="d-flex justify-content-end">
        <memlist-button type="button" variant="primary" @click="saveTermClicked">{{$t('COMMON.SAVE')}}</memlist-button>
      </div>
    </memlist-card>

  </memlist-card>
    
</template>

<script>
import axios from 'axios';
import ConfirmTermsTableRow from '@/view/pages/ml/registrationsetup/ConfirmTermsTableRow.vue';
import { mapGetters } from 'vuex';
import { updateTerms } from '@/core/services/initUserMemlist';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
name: 'confirm-terms-table',
props: ['page','isEvent','category_id'],
  emits: ['show_history_toggled'],
  mixins: [ toasts ],
  components: {
    ConfirmTermsTableRow,
  },

  computed: {
    ...mapGetters(['currentCompanyId'])
  },

  watch: {
    show_history(newcheck, oldcheck) {
      this.$emit('show_history_toggled', newcheck);
    }
  },

  mounted() {
    this.loadTerms();
  },

  methods: {

    loadTerms() {
      this.getTerms()
      .then(terms => {
        this.terms = terms.filter(item => item.audience ? item.audience === 'PUBLIC' : true);
      })
      .catch(err => {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.TERMS.UNABLE_GET'));
      });

    },

    createTermClicked() {
      this.form = {
        name: 'Nytt villkor',
        descr: 'Fyll i text att stå vid checkbox',
        is_mandatory: false,
        company_id: this.currentCompanyId,
        audience: 'PUBLIC'
      }

      this.creating = true;
      this.editing = true;

      this.scrollToEdit();
    },

    isActiveChanged(id, is_active) {
      const term = this.terms.find(item => item.id === id);

      if (!term) {
        console.error('term not found in isActiveChanged');
        return;
      }

      if (term.is_active !== is_active) {
        term.is_active = is_active;
        this.putTerm(id, term)
        .then(res => {
          updateTerms();
          this.toastr('success', this.$t('COMMON.OK'), this.$t('PAGES.TERMS.UPDATED'));
        })
        .catch(err => {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.TERMS.UNABLE_UPDATE'));
        });
      }

    },

    saveTermClicked() {
      if (this.creating) {
        this.postTerm(this.form)
        .then(data => {
          this.creating = false;
          this.form = data;
          this.terms.push(data);
          updateTerms();
          this.toastr('success', this.$t('COMMON.OK'), this.$t('PAGES.TERMS.CREATED'));
        })
        .catch(err => {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.TERMS.UNABLE_CREATE'));
        });
      }
      else {
        this.putTerm(this.form.id, this.form)
        .then(res => {

          const index = this.terms.findIndex(item => item.id === this.form.id);

          this.terms[index] = this.form;
          // Vue3 compatability for Vue.set
          this.terms = [...this.terms];
          updateTerms();
          this.toastr('success', this.$t('COMMON.OK'), this.$t('PAGES.TERMS.UPDATED'));
        })
        .catch(err => {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.TERMS.UNABLE_UPDATE'));
        });

      }
    },

    selectTermClicked(id) {
      this.editing = true;

      for (const t of this.terms) {
        if (t.id === id) {
          this.form = t;
          this.scrollToEdit();
          return;
        }
      }

    },

    async deleteTermClicked(id) {

      try {
        const ok = await this.deleteTerm(id);

        if (ok) {
          this.terms = this.terms.filter(item => item.id !== id);
          this.toastr('success', this.$t('COMMON.OK'), this.$t('PAGES.TERMS.DELETED'));
        }
      }
      catch (err) {
        console.error('deleteTermClicked error', err);

        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.TERMS.UNABLE_DELETE'));
      }

    },

    scrollToEdit() {
      var that = this;
      setTimeout(function () {
        const el = that.$el.getElementsByClassName('scroll-to-container')[0];

        if (el) {
          const yOffset = -70;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    },



    getTerms() {
      return new Promise(async (resolve, reject) => {
        const url =
          this.isEvent
            ?  `/event_category/terms/${this.category_id}`
            : `/company/allterms/${this.currentCompanyId}`

        axios
          .get(url)
          .then(res => {
            if (res.status === 200) {
              resolve(res.data);
            }
            else {
              reject('invalid status ' + res.status);
            }
          })
          .catch(err => {
            reject('error');
            console.error(err);
          });
      });
    },

    getTerm(id) {
      return new Promise(async (resolve, reject) => {
        const url =
          this.isEvent
            ?  `/event_category/term/${id}`
            : `/company/term/${id}`

        axios
          .get(url)
          .then(res => {
            if (res.status === 200) {
              resolve(res.data);
            }
            else {
              reject('invalid status ' + res.status);
            }
          })
          .catch(err => {
            reject('error');
            console.error(err);
          });
      });
    },


    postTerm(data) {

      return new Promise(async (resolve, reject) => {
        const url =
            this.isEvent
              ?  `/event_category/term`
              : `/company/term/${this.currentCompanyId}`;

        if (!this.isEvent) {
          data.company_id = this.currentCompanyId;
        }
        else {
          data.category_id = this.category_id;
        }

        axios
          .post(url, data)
          .then(res => {

            if (res.status === 201) {
              resolve(res.data);
            }
            else {
              reject('invalid status: ' + res.status);
            }
          })
          .catch(err => {
            reject('error');
            console.error(err);
          });
      });


    },

    putTerm(term_id, term) {

      return new Promise(async (resolve, reject) => {

        const url =
            this.isEvent
              ?  `/event_category/term/${term_id}`
              : `/company/term/${term_id}`;

        axios
          .put(url, term)
          .then(res => {

            if (res.status === 204) {
              resolve(true);
            }
            else {
              reject('invalid status ' + res.status);
            }

          })
          .catch(err => {
            console.error(err);
            reject('error');
          });
      });

    },


    async deleteTerm(id) {

      try {
        const url =
          this.isEvent
            ?  `/event_category/term/${id}`
            : `/company/term/${id}`

        const res = await axios.delete(url);

        if (res.status === 200 || res.status === 204) {
          return true;
        }

        return false;
      }
      catch (err) {
        console.error('deleteTerm error', err);
      }

    },

  },

  data() {
    return {
      
      creating: false,
      editing: false,

      terms: [], // list of all terms

      form: { // the current term we are editing
        id: '',
        tid: '',
        name: '',
        descr: '',
        template: '',
        is_mandatory: false,
        is_active: false
      }
    };
  }
};
</script>